exports.version = "2.4.0"


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-client/version.js
// module id = 441
// module chunks = 17